import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from '../components/layout/Navbar';
import Footer from '../components/layout/Footer';
import Hero from '../components/sections/Hero';
import Features from '../components/sections/Features';
import BentoGallery from '../components/sections/BentoGallery';
import HowItWorks from '../components/sections/HowItWorks';
import VideoShowcase from '../components/sections/VideoShowcase';
import PinnedPanels from '../components/sections/PinnedPanels';
import ResellerForm from '../components/sections/ResellerForm';
import DownloadCTA from '../components/sections/DownloadCTA';
import FAQ from '../components/sections/FAQ';

/**
 * HOME PAGE — Full cinematic experience.
 *
 * Section order:
 * 1. Hero — video background, char-split headline, parallax
 * 2. Features — horizontal scrolling gallery (pinned)
 * 3. Bento Gallery — scrubbed bento grid with parallax images
 * 4. How It Works — alternating cards with progress line
 * 5. Video Showcase — two real videos with FLIP expand
 * 6. Pinned Panels — stacking app presentation
 * 7. Reseller Form — become a charging point
 * 8. Download CTA — cinematic close
 * 9. FAQ — accordion
 * 10. Footer
 */
export default function HomePage() {
  const location = useLocation();

  useEffect(() => {
    const section = sessionStorage.getItem('scrollToSection');
    if (section) {
      sessionStorage.removeItem('scrollToSection');
      setTimeout(() => {
        const el = document.getElementById(section);
        if (el) {
          const top = el.getBoundingClientRect().top + window.scrollY - 80;
          window.scrollTo({ top, behavior: 'smooth' });
        }
      }, 400);
    }
  }, [location]);

  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <Features />
        <BentoGallery />
        <HowItWorks />
        <VideoShowcase />
        <PinnedPanels />
        <ResellerForm />
        <DownloadCTA />
        <FAQ />
      </main>
      <Footer />
    </>
  );
}
